export const USER_FORGOT_PASSWORD_REQUEST = "FORGER_PASSWORD/USER_FORGOT_PASSWORD_REQUEST";
export const USER_FORGOT_PASSWORD_SUCCESS = "FORGER_PASSWORD/USER_FORGOT_PASSWORD_SUCCESS";
export const USER_FORGOT_PASSWORD_FAILURE = "FORGER_PASSWORD/USER_FORGOT_PASSWORD_FAILURE";
export const RESET_MESSAGE = "FORGER_PASSWORD/RESET_MESSAGE";



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ForgetPassword/constants.js